import React, { useEffect, useRef, useCallback, useState } from 'react';
import {
  Editor
} from 'slate';
import { ReactEditor, useSlateStatic } from 'slate-react';

import { getStyles } from 'generics/components/basic-text-editor-slate/utilities';

import HelptapEditor from '../../helpers';
import nodeControls from '../../node-menu/control-types';
import BaseElement from '../base';

import './resize.scss';

function Table(props) {

  const element = props.element;
  const elementId = element.id;

  function renderTable() {

    const { attributes, children } = props;

    const tableContainerAttributes = {
      ...attributes,
      className: 'table-wrapper '
    };

    const tableAttributes = {
      id: elementId,
      className: 'table-layout'
    };

    return <div {...tableContainerAttributes}>
      <table {...tableAttributes}>
        <tbody className="table-body">{children}</tbody>
      </table>
    </div>;

  }

  function renderMain() {

    const baseElementProperties = {
      ...props,
      customNodeControls: [
        nodeControls.TABLE_ROWS_AND_COLUMNS_COUNT_INPUT,
        nodeControls.TABLE_ROWS_PADDING_INPUT
      ]
    };

    return <BaseElement {...baseElementProperties}>
      {renderTable()}
    </BaseElement>;

  }

  return renderMain();

}

export function TableBody(props) {

  function renderTableBody() {

    const { attributes, children } = props;

    const elementAttributes = {
      ...attributes,
      className: ''
    };

    elementAttributes.className += ' table-body';

    return <tbody {...elementAttributes}>{children}</tbody>;

  }

  function renderMain() {

    return renderTableBody();

  }

  return renderMain();

}

export function TableRow(props) {

  function renderTableRow() {

    const { attributes, children } = props;

    const elementAttributes = {
      ...attributes,
      className: ''
    };

    elementAttributes.className += ' table-row';

    return <tr {...elementAttributes}>{children}</tr>;

  }

  function renderMain() {

    return renderTableRow();

  }

  return renderMain();

}

export function TableCell(props) {

  const element = props.element;

  const cellReference = useRef(null);
  const editor = useSlateStatic();
  const elementPath = ReactEditor.findPath(editor, element);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const mouseMoveHandler = useCallback(handleMouseMove, []);

  const elementPathReference = Editor.pathRef(editor, elementPath);

  const [rootState, setRootState] = useState({
    resizing: false
  });

  useEffect(function onLoad() {

    return initialize();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function setResizing(resizing) {

    setRootState(function updateRootState(rootState) {

      return {
        ...rootState,
        resizing
      };

    });

  }

  function initialize() {

    return function uninitialize() {

      elementPathReference.unref();

    };

  }

  function handleMouseDown(event) {

    event.preventDefault();
    event.stopPropagation();

    setResizing(true);

    window.addEventListener('mousemove', mouseMoveHandler);

  }

  function handleMouseUp(event) {

    if (event !== void 0) {
      event.preventDefault();
      event.stopPropagation();
    }
    setResizing(false);

    window.removeEventListener('mousemove', mouseMoveHandler);

  }

  function handleMouseMove(event) {

    if (event.which === 0) {
      handleMouseUp();
      return;
    }

    handleResizeHandleMove(event.pageX - cellReference.current.parentNode.getBoundingClientRect().x);

  }

  function handleResizeHandleMove(width) {

    HelptapEditor.table.updateColumnWidth(editor, elementPathReference.current, width, cellReference.current.parentNode);

  }

  function renderResizeHandle() {

    const mainAttributes = {
      className: 'table-cell-resize-handle-main',
      onMouseDown: handleMouseDown,
      onMouseUp: handleMouseUp,
      contentEditable: false
    };

    return <div {...mainAttributes}>
    
    </div>;

  }

  function renderTableCell() {

    const { attributes, children, element } = props;
    const style = getStyles(element);

    style.minWidth = style.maxWidth = style.width;

    const elementAttributes = {
      ...attributes,
      className: '',
      style
    };

    elementAttributes.className += ' table-cell';

    if (rootState.resizing === true) {
      elementAttributes.className += ' table-cell resizing';
    }

    const wrapperAttributes = {
      ref: cellReference,
      className: 'table-cell-resize-handle'
    };
    return <td {...elementAttributes}>
      {children}
      <div {...wrapperAttributes}>
        {renderResizeHandle()}
      </div>
    </td>;

  }

  function renderMain() {

    return renderTableCell();

  }

  return renderMain();

}

export default Table;